import { createContext } from 'react';

interface CommonDataContextInterface {
  isDealerUser: boolean;
  isLenderUser: boolean;
  isAftermarketPartner: boolean;
  isCommonPartner: boolean;
  isSuperAdmin: boolean;
  isSingleAccountOnly: boolean;
  isSuperAdminOrSingleAccount: boolean;
}

export const CommonDataContext = createContext<CommonDataContextInterface>({
  isDealerUser: false,
  isLenderUser: false,
  isAftermarketPartner: false,
  isCommonPartner: false,
  isSuperAdmin: false,
  isSingleAccountOnly: false,
  isSuperAdminOrSingleAccount: false,
});
